var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
const FooterWrapper = styled.div `
  text-align: center;
  margin-top: 7.5rem;
  margin-bottom: 2rem;
`;
const DefaultWrapper = styled.div `
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.INK_400};
  > a {
    margin-left: 0.25rem;
    color: ${({ theme }) => theme.colors.INK_400};
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colors.INK_500};
    }
  }
`;
const Footer = (_a) => {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    return (React.createElement(FooterWrapper, Object.assign({}, restProps), children || (React.createElement(DefaultWrapper, null,
        "\u00A9 2013 - ",
        new Date().getFullYear(),
        React.createElement("a", { target: "_blank", href: "http://www.shoplineapp.com/", rel: "noopener noreferrer" }, "SHOPLINE"),
        ". Asia's E-Commerce Solution."))));
};
export default Footer;
//# sourceMappingURL=index.js.map